import * as React from "react";
import { FunctionComponent } from "react";
import classNames from "classnames";

import "./Control.scss";

interface ControlProps {
    className?: string;
}

const Control: FunctionComponent<ControlProps> = props => {
    const classes = classNames("mi-react-control", props.className);

    return <div className={classes}>{props.children}</div>;
};

export default Control;
